import "./EmptyState.css";

export interface EmptyStateProps {
  title: string;
  description: string;
}

/** Estado vacío legítimo: encabezado + texto, sin depender de iconografía para el sentido. */
export function EmptyState({ title, description }: EmptyStateProps) {
  return (
    <div className="empty-state">
      <p className="empty-state__title">{title}</p>
      <p className="empty-state__description">{description}</p>
    </div>
  );
}
